import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';

import Uuid from '../../../../../support/Uuid';
import NominaIncapacidadesForm from './NominaIncapacidadesForm';
import NominaIncapacidadesList from './NominaIncapacidadesList';

class NominaIncapacidadesManager extends Component {

  state = {};

  handleOnAdd = (data) => {
    const { Incapacidades = {} } = this.props.data;
    const { Incapacidad = [] } = Incapacidades;

    const newData = Incapacidad.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newData);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  handleOnListChange = (data) => {
    this.props.onChange({
      ...this.props.data,
      Incapacidades: {
        Incapacidad: data
      }
    });
  }

  render() {
    const { data } = this.state;
    const { Incapacidades = {} } = this.props.data;
    const { Incapacidad = [] } = Incapacidades;

    return (
      <>
        <div className="pb-4">
          <div>
            <strong className="text-black text-upper">Incapacidades</strong>
          </div>
        </div>

        <div className="pb-4">
          <div className="section pt-2">

            <NominaIncapacidadesForm
              data={ data }
              onAdd={ this.handleOnAdd }
            />

            <NominaIncapacidadesList
              data={ Incapacidad }
              onEdit={ this.handleOnEdit }
              onChange={ this.handleOnListChange }
            />

            <Row>
              <Col>
                <div className="text-muted">
                  “Incapacidades” se deberá informar si se incluye en percepciones la clave 014 “Subsidios por Incapacidad” o bien en deducciones la clave 006 “Descuento por incapacidad”.
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </>
    )
  }
}

export default NominaIncapacidadesManager;